require('angular');

var directives = angular.module('tristarApp.directives', [])

directives.directive('focusMe', ['$timeout', '$parse', function($timeout, $parse) {
	return {
		link: function(scope, element, attrs) {
			var model = $parse(attrs.focusMe);
			scope.$watch(model, function(value) {
				console.log('value=', value);
				if (value === true) {
					$timeout(function() {
						element[0].focus();
					});
				}
			});
		}
	};
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./js/directives.js
 ** module id = 4
 ** module chunks = 0
 **/